import React from 'react';

import Page from '../../common-components/Page';

import StationsSearchForm from './StationsSearchForm';
import StationsTable from './StationsTable';

import * as strings from '../../helpers/strings';
import PaperContainer from '../../common-components/PaperContainer';
// import Typography from '@material-ui/core/Typography';

const StationListScreen = () => (
  <Page title={strings.lblStations}>
    {/* <PaperContainer> */}
      {/* <Typography variant="h5" color={strings.colorPrimary} title={strings.lblStationsList}>{strings.lblStationsList}</Typography> */}
      <StationsSearchForm/>
      <StationsTable/>
    {/* </PaperContainer> */}
  </Page>
)

export default StationListScreen;